import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Icon, type IconName } from '@/design-system/ui/Icon';

/** Shared heading for the content pages: back link, icon tile, title and subtitle. */
export function PageHeader({ icon, title, subtitle, backTo = '/', backLabel = 'بازگشت به صفحه اصلی' }: { icon: IconName; title: string; subtitle?: ReactNode; backTo?: string; backLabel?: string }) {
  return (
    <header className="mb-6 sm:mb-8">
      <Link to={backTo} className="group mb-5 inline-flex items-center gap-1 text-sm font-bold text-ink-2 transition hover:text-navy">
        <Icon name="back" size={16} className="transition group-hover:translate-x-0.5" />
        {backLabel}
      </Link>
      <div className="flex animate-rise items-center gap-3.5">
        <span className="grid size-14 shrink-0 animate-pop place-items-center rounded-[16px] bg-hero text-white shadow-card">
          <Icon name={icon} size={26} />
        </span>
        <div>
          <h1 className="text-xl font-bold leading-snug sm:text-2xl">{title}</h1>
          {subtitle && <p className="mt-0.5 text-sm leading-7 text-ink-2">{subtitle}</p>}
        </div>
      </div>
    </header>
  );
}
